import { useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { DashboardMock, DashboardResMock } from '../types/dashboard.type'

export const useDashboard = (arg: any) => {
  const id = arg?.id
  const { data: staffDashboard, isLoading: staffDashboardIsLoading } = useQuery({
    enabled: !!id,
    queryFn: async () => {
      const endpoint = `staffs/${id}/dashboard`
      const { data } = await AXIOS_INSTANCE.get<DashboardResMock<DashboardMock[]>>(endpoint)
      return data
    },
    queryKey: ['dashboard', { id }]
  })
  return {
    staffDashboard,
    staffDashboardIsLoading
  }
}
